// 2020-06-27export { TropaCambioCorralComponent } from './tropa-cambio-corral.component';